import { ModuleLayoutStyle } from "../../../../services/playground";
export const LI_UI_GAP = 10;
export const FL_UI_GAP = 12;
export const EZBUY_UI_GAP = 12;
export const getGap = (type) => {
    switch (type) {
        case ModuleLayoutStyle.Flower:
        case ModuleLayoutStyle.Orange:
            return EZBUY_UI_GAP;
        case ModuleLayoutStyle.Tomato:
            return LI_UI_GAP;
        default:
            return LI_UI_GAP;
    }
};
export const getTomatoWidth = (col) => {
    switch (col) {
        case 4:
        case 5:
            return 230;
        case 6:
            return 190;
        default:
            return 190;
    }
};
export const getTomatoCol = (col) => {
    return col < 6 ? 5 : 6;
};
